import {
  IEnterpriseObject,
  useBootstrapConfig,
} from '@cisco-sbg/cspe-mfe-shared-library';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import {
  getEnterpriseId,
  getEnterpriseName,
} from '../components/enterprises/selectors';
import { ENTERPRISES, OVERVIEW, USER_ROLES } from '../paths';

export interface IHostUtilities {
  enterpriseDetails: IEnterpriseObject | undefined;
  navigateToInitialPage: () => void;
  navigateToRolesPage: () => void;
  navigateToExternalDocs: (url: string) => void;
}

export const useHostUtilities = (): IHostUtilities => {
  const navigate = useNavigate();
  const { isStandalone, basepath } = useBootstrapConfig();
  let { enterpriseDetails } = useBootstrapConfig();
  const enterpriseId = useSelector(getEnterpriseId);
  const enterpriseName = useSelector(getEnterpriseName);

  const navigateToInitialPage = (): void => {
    navigate(isStandalone ? `/${ENTERPRISES}` : `${basepath}/${OVERVIEW}`);
  };
  const navigateToRolesPage = (): void => {
    navigate(isStandalone ? `/${USER_ROLES}` : `${basepath}/${USER_ROLES}`);
  };

  const navigateToExternalDocs = (url: string): void => {
    window.open(url, '_blank');
  };

  if (isStandalone) {
    enterpriseDetails = {
      ...enterpriseDetails,
      id: enterpriseId,
      name: enterpriseName,
    };
  }
  return {
    navigateToInitialPage,
    navigateToRolesPage,
    enterpriseDetails,
    navigateToExternalDocs,
  };
};
